import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import axiosInstance from '../../main/axios';
import Button from '../../common/form/button';
import Grid from '../../common/layout/grid';
import { exportarOrdensServicoExcel, imprimirOrdensServicoPdf } from './ordemServicoExcelExport';

const FILTRO_TODOS = '';

const TIPOS = [
  { value: 'CORRETIVA', label: 'Corretiva' },
  { value: 'PREVENTIVA', label: 'Preventiva' },
  { value: 'IMPLANTACAO', label: 'Implantação' },
  { value: 'RECLAMACAO', label: 'Reclamação' },
];

const STATUS = [
  { value: 'ABERTA', label: 'Aberta' },
  { value: 'AGUARDANDO_MATERIAL', label: 'Aguardando material' },
  { value: 'EM_ATENDIMENTO', label: 'Em atendimento' },
  { value: 'AGUARDANDO_VALIDACAO', label: 'Aguardando validação' },
  { value: 'FINALIZADA', label: 'Finalizada' },
  { value: 'CANCELADA', label: 'Cancelada' },
];

const FILTROS_INICIAIS = {
  grupo_fisico_id: FILTRO_TODOS,
  controlador_id: FILTRO_TODOS,
  equipe_id: FILTRO_TODOS,
  tipo: FILTRO_TODOS,
  status: FILTRO_TODOS,
  usuario_responsavel_id: FILTRO_TODOS,
  data_inicio: '',
  data_fim: '',
};

class OrdemServicoRelatorioExcelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtros: { ...FILTROS_INICIAIS },
      gerando: false,
      formatoGerando: null,
    };
    this.handleFiltroChange = this.handleFiltroChange.bind(this);
    this.handleGerar = this.handleGerar.bind(this);
    this.handleLimpar = this.handleLimpar.bind(this);
  }

  handleFiltroChange(campo, valor) {
    this.setState(prev => {
      const filtros = { ...prev.filtros, [campo]: valor };
      if (campo === 'grupo_fisico_id') {
        filtros.controlador_id = FILTRO_TODOS;
      }
      return { filtros };
    });
  }

  handleLimpar() {
    this.setState({ filtros: { ...FILTROS_INICIAIS } });
  }

  montarParams() {
    const { filtros } = this.state;
    const params = {};

    if (filtros.grupo_fisico_id) params.grupo_fisico_id = filtros.grupo_fisico_id;
    if (filtros.controlador_id) params.controlador_id = filtros.controlador_id;
    if (filtros.equipe_id) params.equipe_id = filtros.equipe_id;
    if (filtros.tipo) params.tipo = filtros.tipo;
    if (filtros.status) params.status = filtros.status;
    if (filtros.usuario_responsavel_id) params.usuario_responsavel_id = filtros.usuario_responsavel_id;
    if (filtros.data_inicio) params.data_inicio = filtros.data_inicio;
    if (filtros.data_fim) params.data_fim = filtros.data_fim;

    return params;
  }

  montarResumoFiltros(opcoes) {
    const { filtros } = this.state;
    const partes = [];
    const grupos = opcoes.grupos_fisicos || [];
    const equipes = opcoes.equipes || [];
    const usuarios = opcoes.usuarios || [];
    const controladores = opcoes.controladores || [];

    if (filtros.grupo_fisico_id) {
      const g = grupos.find(item => String(item.id) === String(filtros.grupo_fisico_id));
      partes.push(`Grupo: ${g ? g.descricao : filtros.grupo_fisico_id}`);
    }
    if (filtros.controlador_id) {
      const c = controladores.find(item => String(item.id) === String(filtros.controlador_id));
      partes.push(`Controlador: ${c ? `Ctrl ${c.numero_controlador}` : filtros.controlador_id}`);
    }
    if (filtros.equipe_id) {
      const e = equipes.find(item => String(item.id) === String(filtros.equipe_id));
      partes.push(`Equipe: ${e ? e.nome : filtros.equipe_id}`);
    }
    if (filtros.tipo) {
      const t = TIPOS.find(item => item.value === filtros.tipo);
      partes.push(`Tipo: ${t ? t.label : filtros.tipo}`);
    }
    if (filtros.status) {
      const s = STATUS.find(item => item.value === filtros.status);
      partes.push(`Status: ${s ? s.label : filtros.status}`);
    }
    if (filtros.usuario_responsavel_id) {
      const u = usuarios.find(item => String(item.id) === String(filtros.usuario_responsavel_id));
      partes.push(`Usuário: ${u ? u.nome : filtros.usuario_responsavel_id}`);
    }
    if (filtros.data_inicio) partes.push(`De: ${filtros.data_inicio}`);
    if (filtros.data_fim) partes.push(`Até: ${filtros.data_fim}`);

    return partes.length ? partes.join(' · ') : 'Todos os registros';
  }

  async handleGerar(formato) {
    const { filtros } = this.state;
    const { onClose, opcoes } = this.props;

    if (filtros.data_inicio && filtros.data_fim && filtros.data_inicio > filtros.data_fim) {
      toastr.warning('Atenção', 'A data inicial não pode ser maior que a data final.');
      return;
    }

    this.setState({ gerando: true, formatoGerando: formato });
    try {
      const resp = await axiosInstance.get('/manutencao/ordens_servico', { params: this.montarParams() });
      const ordens = resp.data || [];

      if (!ordens.length) {
        toastr.warning('Atenção', 'Nenhuma ordem de serviço encontrada com os filtros informados.');
        return;
      }

      if (formato === 'pdf') {
        imprimirOrdensServicoPdf(ordens, this.montarResumoFiltros(opcoes));
        toastr.success('Sucesso', `${ordens.length} ordem(ns) enviada(s) para impressão em PDF.`);
      } else {
        exportarOrdensServicoExcel(ordens);
        toastr.success('Sucesso', `${ordens.length} ordem(ns) exportada(s) para Excel.`);
      }

      onClose();
    } catch (e) {
      toastr.error('Erro', formato === 'pdf' ? 'Não foi possível gerar o PDF.' : 'Não foi possível gerar o arquivo Excel.');
    } finally {
      this.setState({ gerando: false, formatoGerando: null });
    }
  }

  renderSelect(campo, label, opcoes, cols = '12 6') {
    const { filtros } = this.state;
    return (
      <Grid cols={cols}>
        <div className="form-group form-group-sm">
          <label className="label-gt" htmlFor={`os-relatorio-${campo}`}>
            {label}
          </label>
          <select
            id={`os-relatorio-${campo}`}
            className="form-control"
            value={filtros[campo]}
            onChange={e => this.handleFiltroChange(campo, e.target.value)}
          >
            <option value={FILTRO_TODOS}>Todos</option>
            {opcoes.map(op => (
              <option key={op.value} value={op.value}>
                {op.label}
              </option>
            ))}
          </select>
        </div>
      </Grid>
    );
  }

  render() {
    const { show, onClose, opcoes } = this.props;
    const { filtros, gerando, formatoGerando } = this.state;
    const grupos = opcoes.grupos_fisicos || [];
    const equipes = opcoes.equipes || [];
    const usuarios = opcoes.usuarios || [];
    const controladores = (opcoes.controladores || []).filter(
      c => !filtros.grupo_fisico_id || String(c.grupo_fisico_id) === String(filtros.grupo_fisico_id),
    );

    const opcoesGrupo = grupos.map(g => ({ value: String(g.id), label: g.descricao }));
    const opcoesControlador = controladores.map(c => ({
      value: String(c.id),
      label: `Ctrl ${c.numero_controlador}${c.endereco ? ` — ${c.endereco}` : ''}`,
    }));
    const opcoesEquipe = equipes.map(e => ({ value: String(e.id), label: e.nome }));
    const opcoesUsuario = usuarios.map(u => ({ value: String(u.id), label: u.nome }));

    return (
      <Modal show={show} onHide={onClose} backdrop="static" dialogClassName="os-excel-modal-dialog">
        <div className="os-excel-modal-shell">
          <div className="os-excel-modal-header">
            <div className="os-excel-modal-header-main">
              <div className="os-excel-modal-header-icon">
                <i className="fa fa-print" />
              </div>
              <div>
                <h4>Imprimir relatório de OS</h4>
                <p>Selecione os filtros e escolha o formato de saída: Excel ou PDF.</p>
              </div>
            </div>
            <button type="button" className="os-excel-modal-close" onClick={onClose} aria-label="Fechar">
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="os-excel-modal-body">
            <div className="os-excel-modal-filters simple-cad-form-premium">
              <div className="row">
                {this.renderSelect('grupo_fisico_id', 'Grupo físico', opcoesGrupo)}
                {this.renderSelect('controlador_id', 'Controlador', opcoesControlador)}
                {this.renderSelect('equipe_id', 'Equipe', opcoesEquipe)}
                {this.renderSelect('tipo', 'Tipo', TIPOS)}
                {this.renderSelect('status', 'Status', STATUS)}
                {this.renderSelect('usuario_responsavel_id', 'Usuário responsável', opcoesUsuario)}
                <Grid cols="12 6">
                  <div className="form-group form-group-sm">
                    <label className="label-gt" htmlFor="os-relatorio-data-inicio">
                      Data inicial
                    </label>
                    <input
                      id="os-relatorio-data-inicio"
                      type="date"
                      className="form-control"
                      value={filtros.data_inicio}
                      onChange={e => this.handleFiltroChange('data_inicio', e.target.value)}
                    />
                  </div>
                </Grid>
                <Grid cols="12 6">
                  <div className="form-group form-group-sm">
                    <label className="label-gt" htmlFor="os-relatorio-data-fim">
                      Data final
                    </label>
                    <input
                      id="os-relatorio-data-fim"
                      type="date"
                      className="form-control"
                      value={filtros.data_fim}
                      onChange={e => this.handleFiltroChange('data_fim', e.target.value)}
                    />
                  </div>
                </Grid>
              </div>
            </div>
          </div>

          <div className="os-excel-modal-footer">
            <Button type="button" className="default" icon="eraser" label="Limpar filtros" onClick={this.handleLimpar} />
            <Button type="button" className="default" icon="close" label="Cancelar" onClick={onClose} disabled={gerando} />
            <button
              type="button"
              className="btn btn-primary os-excel-modal-action-btn"
              onClick={() => this.handleGerar('excel')}
              disabled={gerando}
            >
              {gerando && formatoGerando === 'excel' ? (
                <>
                  <i className="fa fa-spinner fa-spin" /> Gerando Excel...
                </>
              ) : (
                <>
                  <i className="fa fa-file-excel" /> Excel
                </>
              )}
            </button>
            <button
              type="button"
              className="btn btn-primary os-excel-modal-action-btn"
              onClick={() => this.handleGerar('pdf')}
              disabled={gerando}
            >
              {gerando && formatoGerando === 'pdf' ? (
                <>
                  <i className="fa fa-spinner fa-spin" /> Gerando PDF...
                </>
              ) : (
                <>
                  <i className="fa fa-file-text-o" /> PDF
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default OrdemServicoRelatorioExcelModal;
